import React, { useMemo, useRef, useState } from 'react';
import { Drawer, Dropdown } from 'antd';
import UpdatePasswordPage from '../../views/passwords/Update'
import InfoTooltip from "../InfoTooltip";
import { CheckBox } from "../form/CheckboxInput";
import { useAuth } from "../../providers/AuthProvider";
import { Link, NavLink as RRNavLink, useLocation } from 'react-router-dom'


const TopNavBar = (props) => {

    const { auth, isValidated, shouldHideNavbar, logout } = useAuth();
    const location = useLocation()
    const [isOpen, setIsOpen] = useState(false);

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const drawerContainerRef = useRef(null);

    const transKey = (append = '') => {
        if (!TB.isObject(auth)) {
            return;
        }

        if (auth.isClient()) {
            return `clients.${append}`;
        }

        if (auth.isTalent()) {
            return `talent.${append}`;
        }

        return `clients.${append}`;
    }



    const logoutUser = async (e) => {
        await setIsDropdownOpen(false)
        await setIsDrawerOpen(false)
        let result = logout().catch(console.warn);
    }

    const clientNavbarLinks = () => {
        if (!auth.hasRegisteredClientOrg()) {
            return [];
        }

        return [
            {
                title: TB.trans('clients.nav.company_projects_link'),
                to: '/client/projects/all',
            },
        ];
    }

    const talentNavbarLinks = () => {
        if (!auth.isActive()) {
            return [];
        }

        return [
            // {
            //     title: TB.trans('talent.nav.dashboard_link'),
            //     to: TalentDashboard.path,
            // },
        ];
    }

    const navbarLinks = () => {
        if (!TB.isObject(auth) || auth.isClient()) {
            return [];
        }

        if (auth.isClient()) {
            return clientNavbarLinks();
        }

        if (auth.isTalent()) {
            return talentNavbarLinks();
        }

        return [];
    }

    const passwordLink = () => {
        return {
            title: TB.trans(
                transKey('nav.password_link')
            ),
            to: UpdatePasswordPage.path,
        };
    }

    const systemAnyDropdownLinks = () => {
        return [
            {
                title: 'System Admin Portal',
                to: '/system',
                external: true,
            },
            {
                title: 'Clients Mgmt Portal',
                to: '/client/manager/projects',
                external: true,
            },
            {
                title: 'Talent Mgmt Portal',
                to: '/talent/manager/talent-vetting',
                external: true
            },
            // {
            //     divider: true,
            // },
            // {
            //     title: TB.trans('clients.nav.profile_link'),
            //     to: '/system/auth/edit-profile',
            // },
            // {
            //     title: 'Change Password',
            //     to: '/system/auth/edit-password',
            // },
            // {
            //     title: 'Notification Settings',
            //     to: '/system/auth/edit-notification-settings',
            // },
        ];
    }

    const talentDropdownLinks = () => {
        const links = [];

        links.push({
            title: 'Email Preferences',
            to: '/account/settings',
        });

        if (!auth?.isTalentSupplierResource()) {
            links.push(
                {
                    title: 'Deactivate Account',
                    to: '/account/deactivate',
                },
                passwordLink(),
            );
        }

        return links;
    }

    const clientDropdownLinks = () => {
        let links = [];

        if (auth.isClientConsultant()) {
            links.push({
                title: 'System Admin Portal',
                to: '/system',
                external: true,
            });
            links.push({
                title: 'Clients Mgmt Portal',
                to: '/client/manager/projects',
                external: true,
            }, {
                title: 'Talent Mgmt Portal',
                to: '/talent/manager/talent-vetting',
                external: true,
            });

            if (auth?.hasRegisteredClientOrg()) {
                links.push({
                    divider: true,
                });
            }
        }

        if (!auth?.hasRegisteredClientOrg()) {
            return links;
        }

        if (auth?.canManageClientResourceTalent()) {

            if (location.pathname.includes('supplier')) {

                links.push({
                    // title: 'Client Dashboard',
                    title: 'Talent Marketplace',
                    to: '/client/dashboard',
                    // external: true,
                })
            } else {
                links.push({
                    // title: 'Supplier Dashboard',
                    title: 'Seller Portal',
                    to: '/supplier',
                    // external: true,
                })
            }
            links.push({
                title: 'Plans',
                to: '/supplier/plans',
            });
            links.push({
                divider: true,
            });
        }

        links.push({
            title: TB.trans('clients.nav.profile_link'),
            to: '/account/my-profile',
        });
        if (auth?.isClientOrTalentUser()) {
            links.push({
                title: 'Email Preferences',
                to: '/account/settings',
            });
        }


        let client = auth?.hasRegisteredClientOrg() && auth?.clientOrg();

        if (!client?.requiresSSOProvider()) {
            links.push(passwordLink());
        }

        if (client?.hasConsultant()) {
            links.push({
                title: TB.trans('clients.nav.company_consultant_link'),
                to: '/client/client-success-rep',
            });
        }

        if (client && (auth?.isClientAdmin() || auth.isClientConsultant())) {
            links = links.concat([
                {
                    divider: true,
                },
                {
                    title: TB.trans('clients.nav.company_profile_link'),
                    to: '/client/org/profile',
                },
                {
                    title: 'Client Users',
                    to: '/client/org/users',
                },
                {
                    title: 'Groups',
                    to: '/client/org/groups',
                },
            ])
        }

        if (auth?.isClientBaseUser() && auth?.client_project_groups?.length > 0) {
            links = links.concat([
                {
                    title: 'My Groups',
                    to: '/client/my-groups',
                }
            ])
        }

        return links;
    }

    const dropdownLinks = () => {
        if (!TB.isObject(auth)) {
            return [];
        }

        if (auth.isClient()) {
            return clientDropdownLinks();
        }
        else if (auth.isTalent()) {
            return talentDropdownLinks();
        }
        else if (auth.isPlatformUser()) {
            return systemAnyDropdownLinks();
        }
        else {
            let links = [
                {
                    title: TB.trans('clients.nav.profile_link'),
                    to: '/client/my-profile',
                },
                passwordLink(),
            ];
            if (auth?.isTalentManager()) {
                links.push({
                    title: 'Email Preferences',
                    to: '/account/settings',
                });
            }

            return links;
        }

        return [];
    }
    const navLinks = navbarLinks();
    const dropLinks = dropdownLinks();
    const menuItems = useMemo(() => {
        let items = dropLinks.map((link, i) => {
            if (link.divider) {
                return {
                    type: 'divider',
                }
            }

            if (!link.to) {
                return {
                    key: `menu-link-${i}`,
                    label: (
                        <h6 className="py-1 px-3 bg-red-100 font-primary text-[13px] whitespace-nowrap">
                            {link.title}
                        </h6>
                    )
                };
            }
            if (link.external) {
                return {
                    key: `menu-link-${i}`,
                    label: (
                        <Link
                            onClick={e => setIsDropdownOpen(false)}
                            to={link.to} target="_blank"
                            className="py-1 px-3 whitespace-nowrap block font-normal">
                            {link.title}
                        </Link>
                    )
                }
            }

            return {
                key: `menu-link-${i}`,
                label: (
                    <Link to={link.to}
                        onClick={e => setIsDropdownOpen(false)}
                        className="block py-1 px-3 whitespace-nowrap font-normal">
                        {link.title}
                    </Link>
                )
            }
        });

        return [
            ...items,
            { type: 'divider' },
            {
                key: 'logout',
                label: (
                    <button type="button" className="text-[14px] py-1 px-3 block w-full text-left"
                        onClick={async () => {
                            await setIsDropdownOpen(false)
                            return logoutUser()
                        }}>
                        {TB.trans(transKey('nav.logout_link'))}
                    </button>
                )
            }
        ]
    }, [dropLinks]);


    const renderItems = () => {

        return (
            <>
                <div className="hidden md:flex flex-1 justify-end">

                    {!auth.isClientManager()
                        && auth.isClient()
                        && auth.hasClientOrg()
                        && (
                            <div className="client-org font-primary">
                                {auth.hasMultipleClientOrgs() ? (
                                    <button
                                        type="button"
                                        className="flex max-w-[400px] items-center justify-end text-left"
                                        onClick={async () => await TB.auth().update({ ...auth, client_organization: null })}
                                    >
                                        <span className="flex-grow line-clamp-1" title={auth.clientOrg().name}>
                                            {auth.clientOrg().name}
                                        </span>
                                        <i className="fa fa-exchange-alt ml-2 text-xs" />
                                    </button>
                                ) : (
                                    <span className="flex max-w-[400px] items-center justify-end text-left">
                                        <span className="flex-grow line-clamp-1" title={auth.clientOrg().name}>
                                            {auth.clientOrg().name}
                                        </span>
                                    </span>
                                )}
                            </div>
                        )
                    }

                    <div className="mx-3 nav-divider" />

                    <Dropdown
                        menu={{ items: menuItems }}
                        trigger={['click']} placement="bottomRight"
                        onOpenChange={open => setIsDropdownOpen(open)} open={isDropdownOpen}>
                        <a onClick={e => e.preventDefault()} className="flex items-center pr-2 font-primary">
                            <span className="mr-1">
                                {auth.first_name}
                            </span>
                            <div className="w-0 h-0
                            border-l-[4px] border-l-transparent
                            border-t-[5px] border-t-black
                            border-r-[4px] border-r-transparent"
                            />
                        </a>
                    </Dropdown>
                </div>
                <div className={`absolute w-full top-[3.7rem] left-0 transition-[height] duration-400 ${isDrawerOpen ? 'h-full' : 'h-0'} md:hidden`} ref={drawerContainerRef}>
                    <Drawer
                        height={"auto"}
                        placement="top"
                        closable={false}
                        onClose={() => setIsDrawerOpen(!isDrawerOpen)}
                        open={isDrawerOpen}
                        getContainer={drawerContainerRef.current}
                        rootStyle={{ position: 'absolute' }}
                    >
                        <ul className="font-primary py-2 border-t border-gray-200 mb-0">
                            {(auth.isClient() || !location.pathname.includes('supplier/')) && (
                                <>
                                    <li className="nav-icon-links-container justify-between" style={{ maxWidth: 'unset' }}>
                                        {clientPortalLinks().map(link => {
                                            let active = link.activePath && TB.includes(location.pathname, link.activePath);
                                            return (
                                                <div className={TB.mapClass("nav-icon-link", { active })} key={link.hint}>
                                                    {link.external ? (
                                                        <a href={link.path} target={link.target} id={TB.slugify(link.hint)} onClick={() => setIsDrawerOpen(!isDrawerOpen)}>
                                                            <i className={link.icon} />
                                                        </a>
                                                    ) : (
                                                        <Link to={link.path} target={link.target} id={TB.slugify(link.hint)} onClick={() => setIsDrawerOpen(!isDrawerOpen)}>
                                                            <i className={link.icon} />
                                                        </Link>
                                                    )}
                                                    {!active && (
                                                        <InfoTooltip type="gray" placement="bottom" target={TB.slugify(link.hint)}>
                                                            {link.hint}
                                                        </InfoTooltip>
                                                    )}
                                                </div>
                                            )
                                        })}
                                    </li>
                                    <li className="border-t border-gray-200 my-2" />
                                </>
                            )}

                            {/* {(auth.isClient() || !location.pathname.includes('supplier/')) && (
                                <>
                                    {clientPortalLinks().map((link, i) => {
                                        if (link.external) {
                                            return (
                                                <li key={`navbarLinkClient${i}`} className="py-1.5">
                                                    <a href={link.path} target={link.target} className="nav-lin py-1.5 whitespace-nowrap" onClick={() => setIsDrawerOpen(!isDrawerOpen)}>
                                                        {link.hint}
                                                    </a>
                                                </li>
                                            )
                                        }
                                        return (
                                            <li key={`navbarLinkClient${i}`} className="py-1.5">
                                                <Link to={link.path} className="nav-lin py-1.5 whitespace-nowrap" onClick={() => setIsDrawerOpen(!isDrawerOpen)}>
                                                    {link.hint}
                                                </Link>
                                            </li>
                                        );
                                    })}

                                    <li className="border-t border-gray-200 my-2" />
                                </>
                            )} */}

                            {navLinks.map((link, i) => {
                                return (
                                    (<li key={`navbarLink${i}`} className="py-1.5 px-4">
                                        <Link to={link.to} className="nav-lin py-1.5 whitespace-nowrap" onClick={() => setIsDrawerOpen(!isDrawerOpen)}>
                                            {link.title}
                                        </Link>
                                    </li>)
                                );
                            })}

                            {dropLinks.map((link, i) => {
                                if (link.divider) {
                                    return (<li key={`mobileNavbarLink${i}`} className="border-t border-gray-200 my-2" />);
                                }

                                if (!link.to) {
                                    return (
                                        (<li key={`mobileNavbarLink${i}`} className="py-1.5 px-4">
                                            <h6 className="dropdown-header py-1.5 whitespace-nowrap" key={`navbar-dropdown-link-${i}`}>
                                                {link.title}
                                            </h6>
                                        </li>)
                                    );
                                }

                                return (
                                    (<li key={`mobileNavbarLink${i}`} className="py-1.5 px-4 md:hidden">
                                        <Link to={link.to} className="py-1.5 whitespace-nowrap" onClick={() => setIsDrawerOpen(!isDrawerOpen)}>
                                            {link.title}
                                        </Link>
                                    </li>)
                                );
                            })}

                            <li className="border-t border-gray-200 my-2" />

                            <li className="py-1.5 px-4">
                                <button type="button" className="font-primary text-[13px] font-medium py-1.5" onClick={logoutUser}>
                                    {TB.trans(transKey('nav.logout_link'))}
                                </button>
                            </li>
                        </ul>
                    </Drawer>
                </div>
            </>
        );
    }


    /*
    * CLIENT PORTAL NAVIGATION
    */
    const clientPortalLinks = () => {

        let links = [
            {
                hint: 'Home',
                icon: 'fas fa-home',
                path: '/client/dashboard',
                activePath: '/client/dashboard',
            },
            {
                hint: 'Projects',
                icon: 'fas fa-border-all',
                path: 'client/projects/all',
                activePath: 'client/projects'
            },
            {
                hint: 'Talent',
                icon: 'fas fa-search',
                path: '/client/browse/talent',
                activePath: 'browse'
            },
            {
                hint: 'Pools',
                icon: 'fas fa-users',
                path: 'client/talent-pool',
                activePath: 'client/talent-pool'
            },
        ];

        if (laravel.platform_settings.Help_Link) {
            links.push({
                hint: 'Help',
                icon: 'far fa-question-circle',
                // path: laravel.platform_settings.Help_Link,
                path: 'https://intercom.help/wripple/en/',
                target: '_blank',
                external: true,
            });
        }
        return links;
    }

    const renderClientPortalLinks = () => {
        if (!auth.isClient() || location.pathname.includes('supplier/')) {
            return null
        }

        return (
            <div className="nav-icon-links-container hidden md:flex">
                {clientPortalLinks().map(link => {
                    let active = link.activePath && TB.includes(location.pathname, link.activePath);
                    return (
                        <div className={TB.mapClass("nav-icon-link", { active })} key={link.hint}>
                            {link.external ? (
                                <a href={link.path} target={link.target} id={TB.slugify(link.hint)}>
                                    <i className={link.icon} />
                                </a>
                            ) : (
                                <Link to={link.path} target={link.target} id={TB.slugify(link.hint)}>
                                    <i className={link.icon} />
                                </Link>
                            )}
                            {!active && (
                                <InfoTooltip type="gray" placement="bottom" target={TB.slugify(link.hint)}>
                                    {link.hint}
                                </InfoTooltip>
                            )}
                        </div>
                    )
                })}
            </div>
        )
    }

    const renderLocalTestSettings = () => {
        if (!auth) return;
        const config = TB.auth().authSettingsConfig(auth)

        let height = config.length * 30;
        height = `calc(${height}px + 1rem)`;

        return (
            <div id="adminSidenav" style={{ height }}>
                <i className="fas settings-icon fa-cog" />

                {TB.map(config, (setting, index) => renderSetting(setting, auth, 1))}

            </div>
        )
    }

    const renderSetting = (setting, auth, level) => {
        if (setting.config) {
            return (
                <div className={`pl-${level} ${level === 2 ? "mt-3" : ""}`} key={setting.label + level}>
                    <p className={`setting-label setting-level-${level}`}>{setting.label}</p>

                    {TB.map(setting.config, (child, index) => {
                        return renderSetting(child, auth, level + 1)
                    })}
                </div>
            )
        }
        return (
            <CheckBox
                checkboxClass="justify-start"
                disabled={false}
                key={TB.slugify(setting.label) + level}
                name={TB.slugify(setting.label)}
                label={setting.label}
                required={false}
                value={setting.value()}
                setValue={(value) => {
                    let updates = { ...auth };

                    if (value || setting.toggle) {
                        let props = setting.setAuth()
                        TB.map(props, (propValue, prop) => {
                            updates = TB.set(updates, prop, propValue)
                        })

                        return TB.auth().update(updates)
                    } else TB.auth().refresh()
                }} />
        )
    }


    if (shouldHideNavbar) {
        return null;
    }

    let renderAuthLinks = TB.isObject(auth);
    if (auth && auth.isTalent() && !auth.isApplicationApproved()) {
        renderAuthLinks = false;
    }

    return (
        <div className="bg-white flex justify-between items-center">

            <div className="flex-1">
                <RRNavLink className="logo-link inline-flex" onClick={() => setIsDrawerOpen(false)}
                    to={location.pathname.includes('supplier/') ? 'supplier/dashboard' : TB.auth().appropriate()}>
                    <span className="logo">
                        <img src={TB.logoBrandImagePath()} alt={laravel.platform_name} />
                    </span>
                </RRNavLink>
            </div>

            <button type="button" onClick={() => setIsDrawerOpen(!isDrawerOpen)} className="py-2.5 px-4 border border-gray-200 rounded mr-2.5 md:hidden">
                <div className="bg-dark-gray w-6 h-0.5 opacity-60 rounded-lg"></div>
                <div className="bg-dark-gray w-6 h-0.5 opacity-60 rounded-lg my-1.5"></div>
                <div className="bg-dark-gray w-6 h-0.5 opacity-60 rounded-lg"></div>
            </button>

            {renderAuthLinks && auth.isTalent() && (
                <div className="registration-header hidden md:flex">
                    <h3>Talent Tools</h3>
                </div>
            )}

            {renderAuthLinks && auth.isClient() && renderClientPortalLinks()}

            {renderAuthLinks ? renderItems() : (
                TB.isObject(auth) && (
                    <h3 className="register-username">
                        {auth.fullName()}
                    </h3>
                )
            )}

            {!renderAuthLinks
                && TB.isObject(laravel.auth_notification_settings)
                && location?.pathname?.startsWith('/settings/notifications/') && (
                    <Link to="/login" onClick={() => { TB.auth().Intended = null }}>
                        Login
                    </Link>
                )}
        </div>
    )
}

export default TopNavBar